import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface UserMessagesFilterProps {
  filterIndex: number;
}

/**
 * Renders a number input with operator selection for filtering by user message count
 */
export const UserMessagesFilter = ({ filterIndex }: UserMessagesFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const minNumUserMessages =
    useWatch({ control, name: `filters.${filterIndex}.minNumUserMessages` }) || '';

  const handleValueChange = (value: string) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue >= 1) {
      const currentFilter = getValues(`filters.${filterIndex}`);
      update(filterIndex, { ...currentFilter, minNumUserMessages: numericValue });
    }
  };

  return (
    <div className="space-y-3">
      <div className="space-y-2">
        <Label htmlFor={`user-messages-value-${filterIndex}`} className="text-sm font-medium">
          {t('analytics.filters.minimumMessages')}
        </Label>
        <Input
          id={`user-messages-value-${filterIndex}`}
          type="number"
          min="1"
          step="1"
          value={minNumUserMessages.toString()}
          onChange={(e) => handleValueChange(e.target.value)}
          className="w-full"
        />
        <p className="text-xs text-muted-foreground">
          {t('analytics.filters.minimumMessagesHelp')}
        </p>
      </div>
    </div>
  );
};
